import { tealsTheme } from '@teals/tokens';

type DeepString<T> = T extends string
  ? string
  : T extends number
    ? number
    : T extends object
      ? { [K in keyof T]: DeepString<T[K]> }
      : T;

export type LuminaTheme = DeepString<typeof tealsTheme>;

export const luminaLightTheme: LuminaTheme = {
  ...tealsTheme,
  colors: {
    ...tealsTheme.colors,
    primary: {
      ...tealsTheme.colors.primary,
      400: '#2d9a8f',
      500: '#2d9a8f',
      600: '#1a7a70',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
      elevated: '#ffffff',
    },
    text: {
      ...tealsTheme.colors.text,
      primary: '#0f172a',
      secondary: '#475569',
      disabled: '#94a3b8',
      hint: '#64748b',
      inverse: '#ffffff',
    },
    border: {
      light: '#e2e8f0',
      main: '#cbd5e1',
      dark: '#94a3b8',
    },
  },
};

export const luminaDarkTheme: LuminaTheme = {
  ...tealsTheme,
  colors: {
    ...tealsTheme.colors,
    primary: {
      ...tealsTheme.colors.primary,
      // Subtle fills for chips / hover states (were washed light teal on dark).
      50: 'rgba(45, 154, 143, 0.15)',
      100: 'rgba(45, 154, 143, 0.25)',
      200: 'rgba(45, 154, 143, 0.4)',
      300: '#4eb8ad',
      400: '#4eb8ad',
      500: '#4eb8ad',
      // Text on active chip fills — lighter for contrast on dark surfaces.
      600: '#a3dfdb',
    },
    // Remap light-scale neutrals so ui-web components (Table, Tabs, FilterChips)
    // that use neutral[50]–[600] for surfaces/borders/text render correctly in dark mode.
    // Keep neutral[0] white for text on primary/colored buttons.
    neutral: {
      ...tealsTheme.colors.neutral,
      50: '#1e293b',
      100: '#334155',
      200: '#475569',
      300: '#64748b',
      400: '#94a3b8',
      500: '#cbd5e1',
      600: '#e2e8f0',
    },
    background: {
      default: '#0f172a',
      paper: '#1e293b',
      elevated: '#334155',
    },
    text: {
      ...tealsTheme.colors.text,
      primary: '#f1f5f9',
      secondary: '#cbd5e1',
      disabled: '#64748b',
      hint: '#94a3b8',
      inverse: '#0f172a',
    },
    border: {
      light: '#334155',
      main: '#475569',
      dark: '#64748b',
    },
  },
};
